import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { AlertSuppressionSetting } from './AlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function usePriceStaggerFloorDialog(
  onOkay: () => void,
  onCancel: () => void,
  viagogoVirtualId?: string | null
) {
  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const key: keyof AlertSuppressionSetting =
    'priceStaggerFloorSuppressionTimestamp';

  const lastSuppressTimestamp = useEventConfirmationDialogSuppressionTimestamp(
    key,
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? lastSuppressTimestamp
      : null;

  return {
    key,
    onOkay,
    onCancel,
    lastTimeStamp,
    bodyText: (
      <Content
        id={ContentId.PricingSettingAutoPriceGroupPriceStaggerViolatesFloors}
      />
    ),
  };
}
